var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    {
      attrs: {
        placeholder: "ABN (11) or ACN (9) digits",
        disabled: _vm.disabled,
        maxlength: "11"
      },
      model: {
        value: _vm.numberValue,
        callback: function($$v) {
          _vm.numberValue = $$v
        },
        expression: "numberValue"
      }
    },
    [
      _vm.isLoading
        ? _c("i", {
            staticClass: "el-input__icon el-icon-loading",
            attrs: { slot: "suffix" },
            slot: "suffix"
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.isAbnValid
        ? _c("i", {
            staticClass: "el-input__icon el-icon-success success-tick",
            attrs: { slot: "suffix" },
            slot: "suffix"
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && !_vm.isAbnValid
        ? _c("i", {
            staticClass: "el-input__icon el-icon-error error-cross",
            attrs: { slot: "suffix" },
            slot: "suffix"
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73537e97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73537e97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/abnAcnInput.vue
// module id = null
// module chunks = 